import { CardViewWebElementBase } from './CardViewWebElementBase';
import { By } from 'selenium-webdriver';
import { SlotProxy, slotProxy } from '@oracle/oraclejet-webdriver';
import { executeWithModules } from '@oracle/oraclejet-webdriver/lib/oj-module-proxy';
/**
/**
 * The component WebElement for [oj-c-card-view](../../jsdocs/oj-c.CardView.html).
 * Do not instantiate this class directly, instead, use
 * [findCardView](../modules.html#findCardView).
 */
export class CardViewWebElement extends CardViewWebElementBase {
  // Put overrides here
  /**
   * Sets the value of "selected" property.
   * Specifies the current selected items in the listview. See the Help documentation for more information.
   * @param selected The value to set for "selected"
   * @override
   * @typeparam K Type of keys
   */
  async changeSelected<K>(selected: Array<K>) {
    await this.whenReady();
    return executeWithModules<K>(
      this.getDriver(),
      ['KeySet'],
      [this, selected],
      ({ KeySetImpl }, ele, selected) => (ele.selected = new KeySetImpl(selected))
    );
  }

  /**
   * Gets the value of "selected" property.
   * Retrieves the current selected items in the listview. See the Help documentation for more information.
   * @override
   * @typeparam K Type of keys
   * @return The value of "selected" property.
   */
  async getSelected<K>(): Promise<Array<K>> {
    await this.whenReady();
    const selected: Array<K> = await this.getDriver().executeScript((ele: any) => {
      const selected = ele.selected.isAddAll()
        ? Array.from(ele.selected.deletedValues())
        : Array.from(ele.selected.values());
      return selected;
    }, this);
    return selected;
  }

  /**
   * Retrieve a SlotProxy which represents a single listview item.
   * @param key The key within the Collection's dataset associated with the item.
   */
  async findItem<T>(itemLocator: { key: T }): Promise<SlotProxy> {
    try {
      await this.whenReady();
      return slotProxy(
        await this.findElement(By.css(`[data-oj-card-item][data-oj-key="${itemLocator.key}"]`))
      );
    } catch (ex) {
      throw Error(
        `No corresponding item found for the itemLocator ${JSON.stringify(itemLocator, null, 2)}`
      );
    }
  }
}
